import { BaseApiClient } from 'lib/services/baseApiClient';
import { atom } from 'recoil';
import type { UserInfo } from 'types/userInfo';

export const JWT_KEY = '@enmon/tools/jwt' as const;
export const USER_INFO_KEY = '@enmon/tools/user' as const;

const loadUserInfo = (): UserInfo | undefined => {
  const json = localStorage.getItem(USER_INFO_KEY);
  try {
    return json ? (JSON.parse(json) as UserInfo) : undefined;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export interface Session {
  jwt?: string;
  userInfo?: UserInfo;
  isAuthenticated: boolean;
}

export const sessionState = atom<Session>({
  key: 'session',
  default: {
    jwt: localStorage.getItem(JWT_KEY) ?? undefined,
    userInfo: loadUserInfo(),
    isAuthenticated: false,
  },
  effects: [
    ({ onSet }) => onSet(({ jwt }) => (jwt ? localStorage.setItem(JWT_KEY, jwt) : localStorage.removeItem(JWT_KEY))),
    ({ onSet }) =>
      onSet(({ userInfo }) =>
        userInfo
          ? localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
          : localStorage.removeItem(USER_INFO_KEY),
      ),
    ({ onSet }) =>
      onSet(({ jwt }) => {
        BaseApiClient.authToken = jwt;
      }),
  ],
});
